import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Unscramble from "../Unscramble/index.js";
import {_genUUIDImpl, isValidUUID} from "./foreign.js";
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const unsafeDecodeUUIDFromString = str => {
  if (isValidUUID(str)) { return str; }
  return Unscramble.decodingError("Invalid UUID: " + Data$dShow.showStringImpl(str));
};
const ufromJSONKeyUUID = {fromJSONKey: /* #__PURE__ */ Unscramble.$FromJSONKeyFunction("FromJSONKeyString", unsafeDecodeUUIDFromString)};
const udecodeUUID = {
  unsafeDecode: x => {
    const $0 = Unscramble.decodeString(x);
    if (isValidUUID($0)) { return $0; }
    return Unscramble.decodingError("Invalid UUID: " + Data$dShow.showStringImpl($0));
  }
};
const toString = v => v;
const showUUID = {show: toString};
const ordUUID = Data$dOrd.ordString;
const genUUID = () => _genUUIDImpl();
const fromString = str => {
  if (isValidUUID(str)) { return Data$dMaybe.$Maybe("Just", str); }
  return Data$dMaybe.Nothing;
};
const forceFromString = str => {
  if (isValidUUID(str)) { return str; }
  return Partial._crashWith("Invalid UUID: " + Data$dShow.showStringImpl(str));
};
const eqUUID = Data$dEq.eqString;
const encodeUUID = {encode: x => x};
const decodeUUID = {
  decode: f => bind(Foreign$dGeneric$dClass.readString(f))(v => {
    if (isValidUUID(v)) { return pure(v); }
    return fail(Foreign.$ForeignError("ForeignError", "Invalid UUID: " + Data$dShow.showStringImpl(v)));
  })
};
export {
  bind,
  decodeUUID,
  encodeUUID,
  eqUUID,
  fail,
  forceFromString,
  fromString,
  genUUID,
  ordUUID,
  pure,
  showUUID,
  toString,
  udecodeUUID,
  ufromJSONKeyUUID,
  unsafeDecodeUUIDFromString
};
export * from "./foreign.js";
